import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isTrialAccess } from '../../helpers/subscription.helpers';
import './TrialBadge.css';

const HIDDEN_ON = [
  '/login',
  '/access',
  '/verify-email',
  '/verify-email-pending',
  '/reset-password',
  '/complete-profile',
  '/subscription',
  '/terms',
];

const TrialIcon = () => (
  <svg
    className="xk-trial-badge__icon"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm.75-12.5h-1.5v5.25l4.5 2.7.75-1.23-3.75-2.22z"
    />
  </svg>
);

const TrialBadge = ({ trial, isAuthenticated }) => {
  const location = useLocation();

  if (!isAuthenticated || !trial) return null;
  if (HIDDEN_ON.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <div className="xk-trial-badge" aria-label="Free trial with limited features">
      <TrialIcon />
      <span className="xk-trial-badge__text">Free Trial</span>
    </div>
  );
};

TrialBadge.propTypes = {
  trial: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
};

TrialBadge.defaultProps = {
  trial: false,
  isAuthenticated: false,
};

const mapStateToProps = (state) => ({
  trial: isTrialAccess(state.subscription.access),
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(TrialBadge);
